import { z } from "zod";

import { organizationRoleSchema } from "./organizations.js";

// Personal API keys: bound to one user in one organization, used by the
// internal CLI and agents. The full token is returned once, at creation.
export const API_KEY_EXPIRATION_DAYS = [30, 90, 365] as const;

export const createApiKeyInputSchema = z.object({
  name: z.string().trim().min(1, "Name is required").max(100),
  expiresInDays: z.union([z.literal(30), z.literal(90), z.literal(365)]),
});
export type CreateApiKeyInput = z.infer<typeof createApiKeyInputSchema>;

export const apiKeySchema = z.object({
  id: z.string(),
  name: z.string(),
  prefix: z.string(),
  expiresAt: z.string(),
  lastUsedAt: z.string().nullable(),
  revokedAt: z.string().nullable(),
  createdAt: z.string(),
});
export type ApiKey = z.infer<typeof apiKeySchema>;

export const apiKeyListResponseSchema = z.object({ data: z.array(apiKeySchema) });

export const apiKeyCreateResponseSchema = z.object({
  data: apiKeySchema.extend({ token: z.string() }),
});
export type ApiKeyCreateResponse = z.infer<typeof apiKeyCreateResponseSchema>;

export const whoamiResponseSchema = z.object({
  data: z.object({
    user: z.object({ id: z.string(), name: z.string(), email: z.string() }),
    organization: z.object({ id: z.string(), name: z.string() }),
    role: organizationRoleSchema,
    authMethod: z.enum(["session", "apiKey"]),
    apiKey: apiKeySchema.pick({ id: true, name: true, prefix: true, expiresAt: true }).nullable(),
  }),
});
export type WhoamiResponse = z.infer<typeof whoamiResponseSchema>;
